"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require(".");
var _Button = _interopRequireDefault(require("../../Button"));
var _ColumnTypeParser = _interopRequireDefault(require("./ColumnTypeParser"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // hepers
// action handler
var actionHandler = function actionHandler(_ref) {
  var contentRenderer = _ref.contentRenderer,
    typeDefination = _ref.type,
    locale = _ref.locale;
  return function (value, row, index) {
    var classes = {
      hiddenStatus: false
    };
    var type = _objectSpread({}, typeDefination);
    if (type.hidden) {
      if (typeof type.hidden === 'function') classes.hiddenStatus = type.hidden(row);else if (typeof type.hidden === 'boolean') classes.hiddenStatus = type.hidden;
    }
    var cls = (0, _classnames.default)("table-action-button", {
      hidden: classes.hiddenStatus
    });
    if (!type.buttonProps) {
      type.buttonProps = {};
    }
    if (type.disabled && typeof type.disabled === 'function') {
      type.disabled = type.disabled(row);
    }
    if (type.disabled === true) {
      type.buttonProps.disabled = true;
    }
    if (type.action === 'edit') {
      // we have editable table we can check if record is editing with this function
      var isEditing = false;
      if (typeof type.isEditing === 'function') {
        isEditing = type.isEditing(row);
      }
      if (isEditing) {
        return type.render(value, row, index);
      }
    }
    return !classes.hiddenStatus && /*#__PURE__*/React.createElement(_Button.default, (0, _extends2.default)({
      type: "ghost",
      size: "small",
      className: cls,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (type.handler) {
          type.handler(row, e, index);
        }
      },
      tabIndex: "0"
    }, type.buttonProps), contentRenderer(value, row, index, locale, type));
  };
};
function checkColumnType(columnData, locale) {
  var column = _.Utils.splitDataIndex(_objectSpread({}, columnData));
  if (column.type && (_ColumnTypeParser.default[column.type] || column.type.action && _ColumnTypeParser.default[column.type.action])) {
    if ((0, _typeof2.default)(column.type) === 'object') {
      column.width = column.width || '44px'; // 24 + 10 * 2
      column.fixed = 'right';
      column.title = '';
      column.align = 'center';
      column.render = actionHandler(_objectSpread(_objectSpread({}, column), {}, {
        locale: locale,
        contentRenderer: _ColumnTypeParser.default[column.type.action]
      }));
    } else {
      if (typeof column.render !== 'function') column.render = _ColumnTypeParser.default[column.type](_objectSpread({}, column));
    }
  }
  return column;
}
var _default = exports.default = {
  checkColumnType: checkColumnType
};